import { WidgetType } from 'constants/loanApplication';
import { COLOR_PALETTE } from 'constants/ui';

export const AUS_NA_TEXT = 'N/A';

export const AUS_NA_FALLBACK_TEXT = '-';

export const AUS_STATUS_ICON_SIZE = 20;

export const STATUS_FIELD_NAME = 'status';

export const AUS_TYPE_FIELD_NAME = 'aus type';

const ARCHIVED_TAG_TEXT = 'Archived';
const ARCHIVED_TAG_BG_COLOR = COLOR_PALETTE.ORANGE[2];
const ARCHIVED_TAG_COLOR = COLOR_PALETTE.ORANGE[7];

const TEST_LOAN_TAG_TEXT = 'TEST';
const TEST_LOAN_TAG_BG_COLOR = COLOR_PALETTE.ORANGE[5];
const TEST_LOAN_TAG_COLOR = COLOR_PALETTE.ORANGE[10];

export const TAG_WIDGET_CONFIGS = {
  [WidgetType.ARCHIVED.id]: {
    text: ARCHIVED_TAG_TEXT,
    backgroundColor: ARCHIVED_TAG_BG_COLOR,
    color: ARCHIVED_TAG_COLOR,
  },
  [WidgetType.TEST_LOAN.id]: {
    text: TEST_LOAN_TAG_TEXT,
    backgroundColor: TEST_LOAN_TAG_BG_COLOR,
    color: TEST_LOAN_TAG_COLOR,
  },
};
